/**
 * Nutrition Facts Overlay
 * Lightweight jQuery-based overlay for displaying nutrition facts with flavor selection
 */

$(document).ready(function() {
  // Nutrition panel image URLs for each flavor
  const nutritionImages = {
    'strawberry-gummies': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/strawberry-nutrition-overlay.png?v=1778871767',
    'sour-lemon-lime-gummies': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/sourlemon-lime-nutrition-overlay.png?v=1778871767',
    'peach-mango-shots': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_6-pack_nutrition-min.jpg?v=1746306334',
    'ginger-shots': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_6-pack_nutrition-min.jpg?v=1746306320',
    'blackberry-shots': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_6-pack_nutrition-min.jpg?v=1746306300',
    'strawberry-kiwi-shots': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_kiwi_6-pack_box_photo-min.jpg?v=1746306340',
    'lemon-lime-shots': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_lime_6-pack_nutrition-min.jpg?v=1746306330',
    'apple-shots': 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_6-pack_nutrition-min.png?v=1746306300'
  };

  // Cache DOM elements
  const $overlay = $('#nutrition-overlay');
  const $openButton = $('#open-nutrition-overlay');
  const $closeButton = $('#close-nutrition-overlay');
  const $flavorDropdown = $('#flavor-dropdown');
  const $nutritionImage = $('#nutrition-panel-image');

  // Initialize with default flavor (strawberry gummies)
  function initializeOverlay() {
    const defaultFlavor = 'strawberry-gummies';
    updateNutritionImage(defaultFlavor);
  }

  // Update nutrition image based on selected flavor
  function updateNutritionImage(flavor) {
    const imageUrl = nutritionImages[flavor];
    
    if (imageUrl) {
      // Add loading state
      $nutritionImage.addClass('loading');
      
      // Preload image to ensure smooth transition
      const img = new Image();
      img.onload = function() {
        $nutritionImage.attr('src', imageUrl);
        $nutritionImage.removeClass('loading');
      };
      img.onerror = function() {
        console.warn('Failed to load nutrition image for flavor:', flavor);
        $nutritionImage.removeClass('loading');
      };
      img.src = imageUrl;
    }
  }

  // Open overlay
  function openOverlay(e) {
    e.preventDefault();
    $overlay.fadeIn(300);
    $('body').addClass('overlay-open').css('overflow', 'hidden');
  }

  // Close overlay
  function closeOverlay() {
    $overlay.fadeOut(300);
    $('body').removeClass('overlay-open').css('overflow', '');
  }

  // Event handlers
  $openButton.on('click', openOverlay);
  
  $closeButton.on('click', closeOverlay);
  
  // Close overlay when clicking outside content area
  $overlay.on('click', function(e) {
    if (e.target === this) {
      closeOverlay();
    }
  });
  
  // Close overlay on Escape key
  $(document).on('keydown', function(e) {
    if (e.keyCode === 27 && $overlay.is(':visible')) {
      closeOverlay();
    }
  });
  
  // Handle flavor selection
  $flavorDropdown.on('change', function() {
    const selectedFlavor = $(this).val();
    updateNutritionImage(selectedFlavor);
  });

  // Initialize overlay
  initializeOverlay();
});
